module.exports = {
      id: "icon-appstore-usage",
      viewBox: "0 0 189.408 63.551",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#icon-appstore",
      toString: function () {
        return this.url;
      }
    }